<template>
  <div class="tva-eninumeri-component">
    <div class="close-button">
      <a @click="$router.back()">
        <svgicon icon="close" width="32" height="32"></svgicon>
      </a>
    </div>
    <Header/>
    <div
      class="background-image"
      :style="{backgroundImage: [`url(${baseUrl}images/${$ml.get('eni_numeri').background}${$tvaMq === 'mobile' ? '_m' : ''}.jpg)`], backgroundPosition: 50+ '%' + index * 30 +'%'}"
    ></div>
    <Scroller
      v-if="$tvaMq === 'desktop'"
      :threshold=".5"
      :top="0"
      :bottom=".9"
      v-on:index="index = $event.value"
      v-on:progress="progress = $event.value"
      v-on:offset="offset = $event.value"
      v-on:activeSections="activeSections = $event.value"
      v-on:direction="direction = $event.value"
    >
      <div ref="background" class="background">
        <div
          class="section"
          v-for="(section, pageIndex) in $ml.get('eni_numeri').content"
          :key="pageIndex"
        >
          <transition name="fade">
            <div :class="['section-wrapper', direction]" v-if="index === pageIndex">
              <div :class="['section-content', {'last' : index === 3}]">
                <div class="line" v-if="pageIndex === 0"></div>
                <h2 class="title" v-if="section.title">{{section.title}}</h2>
                <img v-if="section.image" :src="`${baseUrl}images/${section.image}.svg`">
                <h2 class="number" v-if="section.number">{{section.number}}</h2>
                <h2 class="number-text" v-if="section.text">{{section.text}}</h2>
                <div
                  class="section-columns"
                  v-for="(column, index) in section.sections"
                  :key="index"
                >
                  <p>{{column.title}}</p>
                  <div
                    class="column-block"
                    v-for="(block, blockIndex) in column.blocks"
                    :key="blockIndex"
                    :style="{transitionDelay: 0.3 * blockIndex + 's'}"
                  >
                    <h2>{{block.number}}</h2>
                    <p v-html="block.text"></p>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div ref="foreground">
        <div
          class="fake-section"
          v-for="(section, index) in $ml.get('eni_numeri').content"
          :key="index"
        ></div>
      </div>
    </Scroller>
    <div v-if="$tvaMq !== 'desktop'">
      <div
        class="section"
        v-for="(section, pageIndex) in $ml.get('eni_numeri').content"
        :key="pageIndex"
      >
        <div :class="['section-content', {'first' : pageIndex === 0}]">
          <div class="line" v-if="pageIndex === 0"></div>
          <h2 class="title" v-if="section.title">{{section.title}}</h2>
          <h2 class="number" v-if="section.number">{{section.number}}</h2>
          <h2 class="number-text" v-if="section.text">{{section.text}}</h2>
          <div class="section-columns" v-for="(column, index) in section.sections" :key="index">
            <p>{{column.title}}</p>
            <div
              class="column-block"
              v-for="(block, blockIndex) in column.blocks"
              :key="blockIndex"
              :style="{transitionDelay: 0.3 * blockIndex + 's'}"
            >
              <h2>{{block.number}}</h2>
              <p v-html="block.text"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Scroller from "../utilities/Scroller";
import Header from "../components/Header.vue";

export default {
  props: [],
  components: {
    Scroller,
    Header
  },
  data() {
    return {
      index: 0,
      progress: 0,
      offset: 0,
      direction: "foreward",
      baseUrl: process.env.BASE_URL
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    window.matchMedia("(orientation: portrait)").addListener(function(m) {
      if (m.matches) {
        window.scrollTo(0, 0);
      } else {
        window.scrollTo(100, 0);
      }
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";

.tva-eninumeri-component {
  .background-image {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    transition: all 1.5s ease;
    background-size: cover;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background: rgba(0, 0, 0, 0.3);
    }
  }
  .close-button {
    position: fixed;
    top: 80px;
    right: 40px;
    z-index: 3;
    cursor: pointer;
    .svg-icon {
      fill: white;
      stroke: none;
    }
  }
  .background {
    height: 100%;
    width: 100%;
  }
  .section {
    position: absolute;
    height: calc(100vh - 50px);
    top: 50px;
    left: 0;
    width: 100vw;
    .section-wrapper {
      transition: all 0.5s ease;
      height: 100%;
      &.fade-enter.foreward {
        opacity: 0;
        .section-content {
          transform: translateY(100px);
          .section-columns .column-block {
            transform: translateY(-20px);
          }
        }
      }
      &.fade-enter.backward {
        opacity: 0;
        .section-content {
          transform: translateY(-100px);
          .section-columns .column-block {
            transform: translateY(20px);
          }
        }
      }
      &.fade-leave-to.foreward {
        opacity: 0;
        .section-content {
          transform: translateY(-100px);
          .section-columns .column-block {
            transform: translateY(20px);
          }
        }
      }
      &.fade-leave-to.backward {
        opacity: 0;
        .section-content {
          transform: translateY(100px);
          .section-columns .column-block {
            transform: translateY(-20px);
          }
        }
      }
      .section-content {
        height: 100%;
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transition: all 0.6s ease;
        &.last {
          flex-direction: row;
        }
        .line {
          height: 40%;
          width: 2px;
          position: absolute;
          top: 0;
          left: 50%;
          background: $eni-yellow;
        }
        .number {
          opacity: 0.6;
          color: #ffffff;
          font-family: "Avenir Next";
          font-size: 150px;
          font-weight: 900;
          line-height: 0px;
        }
        .number-text {
          color: $eni-yellow;
          font-family: "Avenir Next";
          font-size: 16px;
          font-weight: bold;
          letter-spacing: 0.8px;
          line-height: 22px;
          text-align: center;
          margin-top: -30px;
        }
        .section-columns {
          height: 100%;
          width: calc(100% / 3);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 0 20px;
          p {
            text-transform: uppercase;
            color: white;
            font-weight: 800;
            letter-spacing: 0.4px;
            text-align: left;
          }

          .column-block {
            display: flex;
            width: 90%;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            border-left: solid 1px $eni-yellow;
            padding: 0 10px;
            margin: 20px 0;
            transition: all 1s ease;
            h2 {
              margin: 0;
              opacity: 0.6;
              color: #f2f2f2;
              font-family: "Avenir Next";
              font-size: 50px;
              font-weight: 900;
              line-height: 50px;
            }
            p {
              text-transform: none;
              text-align: left;
            }
          }
        }
      }
    }
  }
  .fake-section {
    width: 100vw;
    height: calc(100vh - 50px);
    top: 50px;
    position: relative;
  }
}
@media (max-width: 1024px) {
  .tva-eninumeri-component {
    .section {
      width: 100%;
      padding: 0 40px;
      position: relative;
      height: fit-content;
      display: flex;
      flex-direction: column;
      align-items: center;
      .section-content {
        .title {
          margin: 45vh 0;
          text-align: center;
        }
        .line {
          height: 40%;
          width: 2px;
          position: absolute;
          top: 0;
          left: 50%;
          background: $eni-yellow;
        }
        .number {
          opacity: 0.6;
          color: #ffffff;
          font-family: "Avenir Next";
          font-size: 150px;
          font-weight: 900;
          line-height: 0px;
        }
        .number-text {
          color: $eni-yellow;
          font-family: "Avenir Next";
          font-size: 16px;
          font-weight: bold;
          letter-spacing: 0.8px;
          line-height: 22px;
          text-align: center;
          margin-top: -30px;
          margin-bottom: 40vh;
        }
        .section-columns {
          height: 100%;
          width: 70%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-bottom: 80px;
          p {
            text-transform: uppercase;
            color: white;
            font-weight: 800;
            letter-spacing: 0.4px;
            text-align: left;
          }

          .column-block {
            display: flex;
            width: 90%;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            border-left: solid 1px $eni-yellow;
            padding: 0 10px;
            margin: 10px 0;
            transition: all 1s ease;
            h2 {
              margin: 0;
              opacity: 0.6;
              color: #f2f2f2;
              font-family: "Avenir Next";
              font-size: 50px;
              font-weight: 900;
              line-height: 50px;
            }
            p {
              text-transform: none;
              text-align: left;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 720px) {
  .tva-eninumeri-component {
    .close-button {
      top: 70px;
      right: 20px;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }
    .section {
      .section-content {
        .title {
          margin: 40vh 0;
          text-align: center;
        }
        .number {
          font-size: 60px;
        }
        .number-text {
          margin-bottom: 50vh;
        }
        .section-columns {
          width: 100%;
        }
      }
    }
  }
}
</style>